import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "components__cnt-practice_data" }
const _hoisted_2 = {
  key: 0,
  class: "practice_data__not-logged-in"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "generic-form registration-form"
}
const _hoisted_5 = {
  key: 0,
  id: "error_explanation"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Angaben zur Aus- und Weiterbildungsstätte", -1)
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-stack" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "training_centre_type" }, "Art der Aus- und Weiterbildungsstätte", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Bitte auswählen", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", null, "Praxis", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", null, "Klinik", -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { for: "practice_name" }
const _hoisted_16 = { for: "practice_bsnr" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { for: "practice_address" }
const _hoisted_19 = { for: "practice_zip" }
const _hoisted_20 = { for: "practice_city" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Angaben zu Ihrer Person", -1)
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = { class: "form-stack" }
const _hoisted_24 = { for: "role_type" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Bitte auswählen", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "form-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "lanr" }, "LANR", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "practice_training_permission_duration" }, "Dauer der Weiterbildungsberechtigung", -1)
const _hoisted_31 = { class: "form-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "practice_expertises" }, "Schwerpunkte", -1)
const _hoisted_33 = { class: "form-row checkboxes" }
const _hoisted_34 = { class: "form-checkbox" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "is_member_of_bvkj" }, "Ich bin BVKJ-Mitglied", -1)
const _hoisted_36 = { class: "form-checkbox" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "is_member_of_bvkj" }, "Ich bin DGAAP-Mitglied", -1)
const _hoisted_38 = {
  key: 0,
  class: "actions"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("input", {
  class: "button expanded",
  type: "submit",
  value: "Daten absenden"
}, null, -1)
const _hoisted_40 = [
  _hoisted_39
]

import { computed, ref, watch } from 'vue';
  import { useStore } from 'vuex';

  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import HttpMethod from 'vue/applications/shared/endpoints/utils/http-method';
  import UniversalEndpoint from 'vue/applications/frontend/endpoints/universal-endpoint';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-practice_data',
  props: {...cntProps()},
  setup(__props) {

  const props = __props;

  const store = useStore();
  const userData = ref({
    lanr: null,
    is_member_of_bvkj: false,
    is_member_of_dgaap: false,
  });
  const practiceData = ref({
    practice_name: null,
    practice_bsnr: null,
    practice_address: null,
    practice_zip: null,
    practice_city: null,
    practice_expertises: null,
    practice_training_permission_duration: null,
    role_type: null,
  });
  const sending = ref<boolean>(false);
  const errors = ref<Array<any>>([]);
  const training_centre_type = ref<string | null>(null);

  const selectedRole = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.roles
    ) return null;

    return props.contentItem.widget_data.roles.find((role: any) => role.id === practiceData.value.role_type);
  });

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (sending.value) return;

    try {
      sending.value = true;
      errors.value = [];

      const endpoint = new UniversalEndpoint(store);
      // try to upload role request
      const response = await endpoint.request(
        props.contentItem.widget_data.upload_role_request_path,
        HttpMethod.POST,
        {
          user: {
            lanr: userData.value.lanr ?? undefined,
            is_member_of_bvkj: userData.value.is_member_of_bvkj ?? false,
            is_member_of_dgaap: userData.value.is_member_of_dgaap ?? false,
            role_requests_attributes: [{
              practice_name: practiceData.value.practice_name ?? undefined,
              practice_bsnr: practiceData.value.practice_bsnr ?? undefined,
              practice_address: practiceData.value.practice_address ?? undefined,
              practice_zip: practiceData.value.practice_zip ?? undefined,
              practice_city: practiceData.value.practice_city ?? undefined,
              practice_expertises: practiceData.value.practice_expertises ?? undefined,
              practice_training_permission_duration: practiceData.value.practice_training_permission_duration ?? undefined,
              role_type: practiceData.value.role_type ?? undefined,
            }],
          },
          training_centre_type: training_centre_type.value ?? undefined,
        }
      );

      if (response && response.data) {
        if (response.data.success) {
          // redirect
          location.href = props.contentItem.widget_data.redirect_target_after_save;
        } else {
          errors.value = response.data.errors;
        }
      }
    } finally {
      sending.value = false;
    }
  };

  watch(() => training_centre_type.value, () => {
    // empty BSNR since only practices have it
    practiceData.value.practice_bsnr = null;
  });

  watch(() => practiceData.value.role_type, () => {
    // empty following fields since only a WBB have them
    userData.value.lanr = null;
    practiceData.value.practice_training_permission_duration = null;
    practiceData.value.practice_expertises = null;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contentItem)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.contentItem.widget_data.login_path)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Sie müssen sich zunächst "),
                _createElementVNode("a", {
                  href: _ctx.contentItem.widget_data.login_path
                }, " einloggen oder registrieren ", 8, _hoisted_3),
                _createTextVNode(". ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                true
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, indx) => {
                          return (_openBlock(), _createElementBlock("li", { key: indx }, _toDisplayString(error[0]), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("form", { onSubmit: handleFormSubmit }, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((training_centre_type).value = $event)),
                        id: "training_centre_type"
                      }, _hoisted_13, 512), [
                        [_vModelSelect, training_centre_type.value]
                      ])
                    ])
                  ]),
                  (training_centre_type.value != '')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'form-stack': true, 'practice_name': training_centre_type.value == 'Praxis', 'practice_name--large': training_centre_type.value != 'Praxis', 'field_with_errors': !!errors.value['role_requests.practice_name'] })
                          }, [
                            _createElementVNode("label", _hoisted_15, "Name der " + _toDisplayString(training_centre_type.value), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "practice_name",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((practiceData.value.practice_name) = $event))
                            }, null, 512), [
                              [_vModelText, practiceData.value.practice_name]
                            ])
                          ], 2),
                          (training_centre_type.value == 'Praxis')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["form-stack practice_bsnr--short", { 'field_with_errors': !!errors.value['role_requests.practice_bsnr'] }])
                              }, [
                                _createElementVNode("label", _hoisted_16, "BSNR der " + _toDisplayString(training_centre_type.value), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  maxlength: "9",
                                  id: "practice_bsnr",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((practiceData.value.practice_bsnr) = $event))
                                }, null, 512), [
                                  [_vModelText, practiceData.value.practice_bsnr]
                                ])
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["form-stack practice_address", { 'field_with_errors': !!errors.value['role_requests.practice_address'] }])
                          }, [
                            _createElementVNode("label", _hoisted_18, "Straße und Hausnummer der " + _toDisplayString(training_centre_type.value), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "practice_address",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((practiceData.value.practice_address) = $event))
                            }, null, 512), [
                              [_vModelText, practiceData.value.practice_address]
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["form-stack practice_zip", { 'field_with_errors': !!errors.value['role_requests.practice_zip'] }])
                          }, [
                            _createElementVNode("label", _hoisted_19, "PLZ der " + _toDisplayString(training_centre_type.value), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              maxlength: "5",
                              id: "practice_zip",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((practiceData.value.practice_zip) = $event))
                            }, null, 512), [
                              [_vModelText, practiceData.value.practice_zip]
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["form-stack practice_city", { 'field_with_errors': !!errors.value['role_requests.practice_city'] }])
                          }, [
                            _createElementVNode("label", _hoisted_20, "Ort der " + _toDisplayString(training_centre_type.value), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "practice_city",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((practiceData.value.practice_city) = $event))
                            }, null, 512), [
                              [_vModelText, practiceData.value.practice_city]
                            ])
                          ], 2)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, "Ich möchte " + _toDisplayString(_ctx.contentItem.widget_data.app_flavor_name) + " verwenden als", 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((practiceData.value.role_type) = $event)),
                        id: "role_type"
                      }, [
                        _hoisted_25,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.widget_data.roles, (role) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: role.id,
                            value: role.id
                          }, _toDisplayString(role.label), 9, _hoisted_26))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, practiceData.value.role_type]
                      ])
                    ])
                  ]),
                  (practiceData.value.role_type == 'trainee')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Die Angabe der Praxidaten und die Lizenzbestellung wird von Ihrer/Ihrem Weiterbildungsberechtigten vorgenommen. Bis zur Genehmigung der Lizenz können Sie kostenfrei die Schnupperversion verwenden."))
                    : (practiceData.value.role_type != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_28, [
                            (selectedRole.value.prompt_lanr)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["form-stack lanr", { 'field_with_errors': !!errors.value['lanr'] }])
                                }, [
                                  _hoisted_29,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    id: "lanr",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((userData.value.lanr) = $event))
                                  }, null, 512), [
                                    [_vModelText, userData.value.lanr]
                                  ])
                                ], 2))
                              : _createCommentVNode("", true),
                            (selectedRole.value.prompt_practice_training_permission_duration)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(["form-stack practice_training_permission_duration", { 'field_with_errors': !!errors.value['role_requests.practice_training_permission_duration'] }])
                                }, [
                                  _hoisted_30,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    id: "practice_training_permission_duration",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((practiceData.value.practice_training_permission_duration) = $event))
                                  }, null, 512), [
                                    [_vModelText, practiceData.value.practice_training_permission_duration]
                                  ])
                                ], 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            (selectedRole.value.prompt_practice_expertises)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["form-stack practice_expertises", { 'field_with_errors': !!errors.value['role_requests.practice_expertises'] }])
                                }, [
                                  _hoisted_32,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    id: "practice_expertises",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((practiceData.value.practice_expertises) = $event))
                                  }, null, 512), [
                                    [_vModelText, practiceData.value.practice_expertises]
                                  ])
                                ], 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "is_member_of_bvkj",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((userData.value.is_member_of_bvkj) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, userData.value.is_member_of_bvkj]
                              ]),
                              _hoisted_35
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "is_member_of_dgaap",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userData.value.is_member_of_dgaap) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, userData.value.is_member_of_dgaap]
                              ]),
                              _hoisted_37
                            ])
                          ]),
                          (training_centre_type.value != '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                ], 32)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})